import {InsightEmpty} from "../InsightEmpty/InsightEmpty";
import {InsightChartContainer, InsightChartContainerProps} from "../InsightChartContainer/InsightChartContainer";
import {LineChart, LineChartBucketData, LineChartData, LineChartProps} from "../../chart/LineChart/LineChart";
import {PropsWithChildren, useMemo} from "react";
import {TimeChartData} from "../../chart/TimeChart/TimeChart";
import {Point} from "chart.js";

export type InsightTimeChartProps = Omit<InsightChartContainerProps, 'children'> & Omit<LineChartProps, 'data'> & {
  data?: TimeChartData;
}

export const InsightTimeChart = (props: PropsWithChildren<InsightTimeChartProps>) => {
  const {
    id,
    data,
    stacked,
    yAxisTitle,
    xAxisTitle,
    tooltipPos,
    children,
    ...rest
  } = props

  const chartData: LineChartData | undefined = useMemo(() => {
    if (data) {

      const buckets: Record<string, LineChartBucketData> = {}

      for (const key of Object.keys(data.buckets)) {
        const lineValues: (number | Point | null)[] = []

        for (const timeValue of data.buckets[key].values) {

          let lineValue: number | Point | null = null

          if (timeValue == null) {
            lineValue = null
          } else if (typeof timeValue === 'number') {
            lineValue = timeValue
          } else {
            lineValue = {
              x: timeValue[0],
              y: timeValue[1]
            } as Point
          }

          lineValues.push(lineValue)
        }

        buckets[key] = {
          values: lineValues
        }
      }

      return {
        titles: data.titles,
        buckets: buckets
      }
    }
    return undefined
  }, [data])

  if (!data || data.titles.length === 0) {
    return (
      <InsightEmpty {...rest} />
    )
  }

  return (
    <InsightChartContainer {...rest}>
      <LineChart
        id={id}
        data={chartData}
        stacked={stacked}
        yAxisTitle={yAxisTitle}
        xAxisTitle={xAxisTitle}
        tooltipPos={tooltipPos}
      />
      {children}
    </InsightChartContainer>
  )
}
